import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect } from "react";
import { a as useToggletipContext, b as useMergeRefs, F as FloatingPortal, c as FloatingFocusManager, d as FloatingArrow } from "../../../../chunks/useToggletip-DMdwuKzA.js";
import { s as styles } from "../../../../chunks/Toggletip.module-CjrKH5q1.js";
const ToggletipPopover = forwardRef(
  function ToggletipPopover2({ style, id, ...props }, propRef) {
    const { arrowRef, context: floatingContext, ...context } = useToggletipContext();
    const ref = useMergeRefs([context.refs.setFloating, propRef]);
    useEffect(() => {
      function handleKeyDown(event) {
        if (event.key === "Tab" && floatingContext.open) {
          floatingContext.onOpenChange(false);
        }
      }
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }, [floatingContext]);
    if (!floatingContext.open) return null;
    return /* @__PURE__ */ jsx(FloatingPortal, { id, children: /* @__PURE__ */ jsx(FloatingFocusManager, { context: floatingContext, initialFocus: -1, children: /* @__PURE__ */ jsxs(
      "div",
      {
        ref,
        style: { ...context.floatingStyles, ...style },
        className: styles.toggletipPopover,
        "aria-labelledby": context.labelId,
        ...context.getFloatingProps(props),
        children: [
          props.children,
          /* @__PURE__ */ jsx(
            FloatingArrow,
            {
              ref: arrowRef,
              context: floatingContext,
              className: styles.toggletipArrow
            }
          )
        ]
      }
    ) }) });
  }
);
export {
  ToggletipPopover
};
